export default __webpack_public_path__ + "static/media/flow.b582c559.png";